import { jwtDecode } from "jwt-decode";

const isTokenValid = (token) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return false;
    const currentTime = Date.now() / 1000;
    return currentTime < exp;
  } catch (error) {
    console.error("Invalid token:", error);
    return false;
  }
};

export const checkTokenAndNavigate = (navigate) => {
  const accessToken = localStorage.getItem("digital-form-accesstoken");
  const refreshToken = localStorage.getItem("digital-form-refresh_token");
  const idToken = localStorage.getItem("digital-form-idtoken");
  const userDetails = localStorage.getItem("digital-form-user_details");
  const dept_id = localStorage.getItem("digital-form-dept-id");
  const practice = localStorage.getItem("digital-form-dept-practice");

  if (accessToken && refreshToken && idToken && userDetails && dept_id && practice) {
    const isAccessValid = isTokenValid(accessToken);

    if (isAccessValid) {
      navigate("/daily-appointments");
      return;
    }

    console.warn("Access token has expired. Checking refresh token...");

    const isRefreshValid = isTokenValid(refreshToken);

    if (isRefreshValid) {
      // Optionally call token refresh API here
      console.warn("Refresh token is still valid. You may attempt to refresh tokens.");
      // e.g., call refresh endpoint, then update localStorage
      // For now, fallback to login:
      navigate("/daily-appointments");
    } else {
      console.warn("Both access and refresh tokens have expired.");
      localStorage.clear();
      navigate("/");
    }
  } else {
    console.warn("Required auth info missing.");
    localStorage.clear();
    navigate("/");
  }
};
